// export const USE_ROUTER = true;
// export const SINGLE_APP = 'MS'; //// e.g. TA or 'TA' (not used if USE_ROUTER is true)

export const MORE_INLINE = 'MORE COMING SOON';
// export const FOOTER = 'MORE GAMES COMING SOON';
export const FOOTER = 'Thank you for playing Beautiful Mind Games. If you like it, please give it a thumbs up.';

//// APP_URL is not used on Home Page if FOOTER is true
// export const APP_URL = 'https://beautifulmindgames.com';
// export const APP_URL = 'https://bmgomg.web.app';
// export const APP_URL = 'localhost:5296';

// export const DEV_VERSION = '2019-10-04';

// export const SHARE_URL = 'https://beautifulmindgames.com/';
export const SHARE_URL = 'https://crazygames.com/game/beautiful-mind-games/';

// export const PROMPT_TO_INSTALL = true;
